import { render, staticRenderFns } from "./FeatureList.vue?vue&type=template&id=59a2ae48&"
import script from "./FeatureList.vue?vue&type=script&lang=js&"
export * from "./FeatureList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QList,QItem,QItemSection,QItemLabel,QBadge,QIcon,QTooltip,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QList,QItem,QItemSection,QItemLabel,QBadge,QIcon,QTooltip})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
